// TODO: Move to common/shared
import React, { Component } from 'react';
import PropTypes from 'prop-types';

export const makeStacker = (WrappedComponent) => {
  const MakeStacker = props => (
    <ReactStacker>
      <WrappedComponent {...props} />
    </ReactStacker>
  );
  MakeStacker.displayName = `MakeStacker(${WrappedComponent.displayName || WrappedComponent.name})`;
  return MakeStacker;
};

export default class ReactStacker extends Component {
  static propTypes = {
    children: PropTypes.element,
  };

  constructor(props) {
    super(props);

    this.state = {
      stack: [],
    };
  }

  handlePushView = (element) => {
    this.setState({
      stack: [element, ...this.state.stack],
    });
  }

  handlePopView = () => {
    const stack = this.state.stack.slice(1);
    this.setState({ stack });
  }

  render() {
    const { children: root, ...restProps } = this.props;

    const view = this.state.stack[0];
    if (!view) {
      return React.cloneElement(root, {
        ...restProps,
        ...root.props,
        pushView: this.handlePushView,
      });
    }

    return React.cloneElement(view, {
      ...restProps,
      ...view.props,
      pushView: this.handlePushView,
      popView: this.handlePopView,
    });
  }
}
